/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor(containerSelector) {
    this.container = document.querySelector(containerSelector);
    if (!this.container) return; // Exit if container not found

    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search'); // Consider how this affects multiple instances
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');

    this.setupEventListeners();
  }

setupEventListeners() {
  this.form.addEventListener('submit', (event) => this.onFormSubmit(event));

  this.input.addEventListener('input', debounce((event) => {
    this.onChange(event);
  }, 300));

  Array.from(this.button).forEach((item) => {
    item.addEventListener('click', (event) => this.toggleSearchDrawer(event));
  });

  // Update handler for .side-panel-close buttons
  const closeButtons = this.container.querySelectorAll('.side-panel-close');
  closeButtons.forEach(button => {
    button.addEventListener('click', () => {
      this.predictiveSearchResults.classList.remove('active');
      this.container.classList.remove('active'); // Ensure root container also reflects this change
    });
  });
}

  toggleSearchDrawer(event) {
    event.preventDefault();
    document.body.classList.toggle('open-cc');
    this.container.classList.toggle('active');
    if (this.container.classList.contains('active')) {
      setTimeout(() => this.input.focus({ preventScroll: true }), 100);
      dispatchCustomEvent('search:open'); // Ensure this is compatible with multiple instances
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();
  
    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      this.container.classList.remove('active'); // Remove active class from root container
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.container.classList.add('active'); // Add active class to root container
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');


    submitButton.addEventListener('click', () => {
      _this.form.submit();
    });
  }

  close() {
    this.container.classList.remove('active');
  }
}

// Debounce function needs to be defined if not already available
function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    let context = this, args = arguments;
    let later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// Example initialization for multiple instances
document.addEventListener('DOMContentLoaded', () => {
  // Assuming there are multiple search containers identified by unique classes or IDs
  const searchContainers = ['#Search-Drawer--Desktop', '#Search-Drawer']; // Example selectors
  searchContainers.forEach((selector) => {
    new PredictiveSearch(selector);
  });
});